// import digitalImg from '../../images/services/digital.jpg';
import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const DigitalTransformationAdvisory = () => {
  const serviceData = {
    title: "Digital Transformation Advisory",
    heading: "Digital Transformation Advisory",
    image: subTopicImages["Digital Transformation Advisory"],
    intro: "",
    description: [
      "We guide digital enablement initiatives from a finance-led perspective, helping clients adopt ERP systems, process automation, MIS analytics and data governance frameworks — ensuring technology genuinely improves reporting, insight and operational discipline.",
    ],
    services: [],
    benefitsIntro: "",
    benefits: [],
    research: "",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default DigitalTransformationAdvisory;
